import script from "./pedidosPendientesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./pedidosPendientesTable.vue?vue&type=script&setup=true&lang=ts"

import "./pedidosPendientesTable.vue?vue&type=style&index=0&id=39643b25&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39643b25"]])

export default __exports__